import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
import { action, observable } from 'mobx';
import { attachFrontendTrackingIds, DiscoveryItemImpressionEvent } from '@udemy/browse-event-tracking';
import { DiscoveryAPI } from '@udemy/discovery-api';
import { UnitProcessor } from '../external/browse/lib/unit-processor';
export let DiscoveryUnitsContainerStore = (_dec = action('Receive units'), _class = class DiscoveryUnitsContainerStore {
  /**
   * @param {{units?: any[]; pageType?: string; pageObjectId?: number | null; pageObject?: Record<string, unknown>;}} args
   * @param {Object?} globalOverrides UDData object to feed DiscoveryAPI params
   */
  constructor({
    units = [],
    pageType = '',
    pageObjectId = null,
    pageObject = {}
  }, globalOverrides) {
    this.backendSource = DiscoveryItemImpressionEvent.backendSourceOptions.DISCOVERY;
    this.discoveryAPI = void 0;
    _initializerDefineProperty(this, "error", _descriptor, this);
    _initializerDefineProperty(this, "firstLoad", _descriptor2, this);
    _initializerDefineProperty(this, "from", _descriptor3, this);
    _initializerDefineProperty(this, "hasMore", _descriptor4, this);
    this.itemCount = 12;
    _initializerDefineProperty(this, "loading", _descriptor5, this);
    _initializerDefineProperty(this, "pageObject", _descriptor6, this);
    _initializerDefineProperty(this, "pageObjectId", _descriptor7, this);
    this.pageSize = 3;
    _initializerDefineProperty(this, "pageType", _descriptor8, this);
    _initializerDefineProperty(this, "units", _descriptor9, this);
    this.discoveryAPI = new DiscoveryAPI({}, globalOverrides);
    this.error = null;
    this.firstLoad = !units.length;
    this.from = units.length;
    this.loading = false;
    this.pageObject = pageObject;
    this.pageObjectId = pageObjectId;
    this.pageType = pageType;
    this.units = units;
  }
  async fetchUnits(options) {
    try {
      var _response$last_index;
      if (this.loading || !this.hasMore || this.error) {
        return;
      }
      this.loading = true;
      const requestOptions = this.getRequestOptions(options);
      const response = await this.discoveryAPI.loadUnits(this.pageType, requestOptions);
      const units = response.results;
      this.receiveUnits(units);
      this.from = ((_response$last_index = response.last_index) !== null && _response$last_index !== void 0 ? _response$last_index : 0) + 1;
      this.hasMore = response.has_more;
      this.removeFirstLoad();
      return units;
    } catch (e) {
      this.receiveError(e);
    }
    this.removeFirstLoad();
  }
  getRequestOptions(options = {}) {
    const defaultOptions = {
      from: this.from,
      pageSize: this.pageSize,
      itemCount: this.itemCount
    };
    return {
      ...(this.pageObjectId && {
        pageObjectId: this.pageObjectId
      }),
      ...this.pageObject,
      ...defaultOptions,
      ...options
    };
  }
  processPreloadedUnits() {
    const requestOptions = this.getRequestOptions({
      from: 0
    });
    this.units = UnitProcessor.processUnits(requestOptions, this.units, this.pageType);
  }
  receiveUnits(units) {
    for (const unit of units) {
      if (unit.items) {
        attachFrontendTrackingIds(unit.items);
      }
    }
    this.loading = false;
    const allUnits = this.units.concat(units);
    const requestOptions = this.getRequestOptions();
    this.units = UnitProcessor.processUnits(requestOptions, allUnits, this.pageType);
  }
  receiveError(error) {
    this.loading = false;
    this.error = error;
  }
  removeFirstLoad() {
    this.firstLoad = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "firstLoad", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "from", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasMore", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pageObject", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "pageObjectId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "pageType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "units", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "fetchUnits", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchUnits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processPreloadedUnits", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processPreloadedUnits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "receiveUnits", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "receiveUnits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "receiveError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "receiveError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeFirstLoad", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeFirstLoad"), _class.prototype), _class);
//# sourceMappingURL=discovery-units-container.mobx-store.js.map